import React from 'react'
import { Redirect } from 'react-router-dom'

import { navigationPaths } from 'app/config'

// The old Centre Audit › Teacher Scorecard link (bookmarks, Slack) lands on
// its new home: Centre Analytics › Centre Health › Preschool Quality & Ops,
// scorecard card open (28 Oct).
const MovedToCentreHealth = () => (
  <Redirect
    to={{
      pathname: navigationPaths.centreAnalyticsCentreHealth,
      search: `?${new URLSearchParams({
        tab: 'Quality and Ops',
        view: 'teachers'
      })}`
    }}
  />
)

export default MovedToCentreHealth
